import { css } from '@emotion/react';
import { useMemo } from 'react';
import { colors, Table, Row, Text } from 'common-components';
import { ColumnsType } from 'antd/lib/table';
import { CertificationUserTestQuestionType } from '@types';
import { useAppTranslation } from '@hooks';
import { formatPercent, formatTicksDuration } from '@utils';

type CertificationTablePropsType = {
  questionsRespondentFiltered: CertificationUserTestQuestionType[]
};

const CertificationTable = ({ questionsRespondentFiltered }: CertificationTablePropsType) => {
  const { translate } = useAppTranslation();

  const tableColumns: ColumnsType<CertificationUserTestQuestionType> = useMemo(
    () => [
      {
        title: translate('certification.table.questionId'),
        dataIndex: 'idCertificationUserTestQuestion',
        key: 'idCertificationUserTestQuestion',
        render: (id: CertificationUserTestQuestionType['idCertificationUserTestQuestion']) => (
          <Row
            css={css`
              width: 907px;
            `}
            align={'middle'}
          >
            <Text size="xs" color={colors.gray900} style={{ fontWeight: 500 }}>
              #{id}
            </Text>
          </Row>
        ),
      },
      {
        title: translate('certification.table.duration'),
        dataIndex: 'duration',
        key: 'duration',
        render: (duration: CertificationUserTestQuestionType['duration']) => (
          <Row
            align={'middle'}
            css={css`
              gap: 18px;
            `}
          >
            <Text>{formatTicksDuration(duration)}</Text>
            {/*<PercentTag state="positive" withIcon={false}>*/}
            {/*	TOP 1%*/}
            {/*</PercentTag>*/}
          </Row>
        ),
      },
      {
        title: translate('certification.table.score'),
        dataIndex: 'mark',
        key: 'mark',
        render: (mark: CertificationUserTestQuestionType['mark']) => (
          <Row
            align={'middle'}
            css={css`
              gap: 18px;
            `}
          >
            <Text style={{ whiteSpace: 'nowrap' }}>{formatPercent(mark)}</Text>
            {/*<PercentTag state="positive" withIcon={false}>*/}
            {/*	TOP 1%*/}
            {/*</PercentTag>*/}
          </Row>
        ),
      },
    ],
    [],
  );

  return <Table data={questionsRespondentFiltered} rowKey="idCertificationUserTestQuestion" columns={tableColumns} />;
};

export default CertificationTable;
